class ComplementarySlider {
  static observer = null;

  constructor() {
    console.log('ComplementarySlider: Initializing...');
    this.init();
  }

  init() {
    // Find the slider container
    this.sliderComponent = document.querySelector('.complementary-products__container');
    console.log('Found slider component:', !!this.sliderComponent);

    if (!this.sliderComponent) {
      console.warn('Slider component not found, will try again in 500ms');
      setTimeout(() => this.init(), 500);
      return;
    }

    // Find the actual slide container
    this.container = this.sliderComponent.querySelector('.complementary-slide');
    this.dots = this.sliderComponent.querySelectorAll('.complementary-dot');
    this.items = this.container?.querySelector('.list-unstyled')?.children;
    
    console.log('Elements found:', {
      container: !!this.container,
      containerClass: this.container?.className,
      dotsCount: this.dots.length,
      itemsCount: this.items?.length
    });
    
    if (!this.container || !this.dots.length || !this.items?.length) {
      console.warn('Missing required elements - will try again in 500ms');
      console.log('Container:', this.container);
      console.log('Dots:', Array.from(this.dots).map(dot => dot.className));
      console.log('Items:', Array.from(this.items || []).map(item => item.className));
      setTimeout(() => this.init(), 500);
      return;
    }
    
    // Enable pointer events on the container
    this.container.style.pointerEvents = 'auto';
    this.container.style.userSelect = 'auto';
    
    this.initDots();
    this.initScroll();
    console.log('ComplementarySlider: Initialization complete');
  }

  initDots() {
    console.log('Initializing dots interaction');
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        console.log('Dot clicked:', index);
        const targetItem = this.items[index];
        if (!targetItem) {
          console.warn('Target item not found for index:', index);
          return;
        }

        // Calculate offset to center the item
        const containerWidth = this.container.offsetWidth;
        const itemWidth = targetItem.offsetWidth;
        const itemGap = 8; // Gap between items
        const scrollOffset = targetItem.offsetLeft - (containerWidth - itemWidth) / 2;
        
        console.log('Scroll calculation:', {
          containerWidth,
          itemWidth,
          itemOffsetLeft: targetItem.offsetLeft,
          calculatedOffset: scrollOffset
        });

        // Smooth scroll to the target position
        this.container.scrollTo({
          left: scrollOffset,
          behavior: 'smooth'
        });

        this.updateActiveDot(index);
      });
    });
  }

  initScroll() {
    console.log('Initializing scroll tracking');
    let debounceTimer;
    
    const handleScroll = () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        const scrollPosition = this.container.scrollLeft;
        const containerWidth = this.container.offsetWidth;
        const containerCenter = scrollPosition + (containerWidth / 2);

        // Find which item is most visible in the center
        let mostVisibleIndex = 0;
        let maxVisibility = -1;

        Array.from(this.items).forEach((item, index) => {
          const itemLeft = item.offsetLeft;
          const itemWidth = item.offsetWidth;
          const itemCenter = itemLeft + (itemWidth / 2);
          
          // Calculate how centered this item is
          const distanceFromCenter = Math.abs(containerCenter - itemCenter);
          const visibility = 1 - (distanceFromCenter / containerWidth);

          if (visibility > maxVisibility) {
            maxVisibility = visibility;
            mostVisibleIndex = index;
          }
        });

        // If at start, use first dot, if at end use last dot, otherwise use most visible
        const isAtStart = scrollPosition <= 5;
        const isNearEnd = scrollPosition + containerWidth >= this.container.scrollWidth - 20;
        const activeIndex = isAtStart ? 0 : (isNearEnd ? this.dots.length - 1 : mostVisibleIndex);

        this.updateActiveDot(activeIndex);
      }, 50);
    };

    // Add scroll event listener
    this.container.addEventListener('scroll', handleScroll);

    // Also handle touch events for better mobile experience
    let startX, startScroll;
    
    this.container.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startScroll = this.container.scrollLeft;
    }, { passive: true });

    this.container.addEventListener('touchend', () => {
      handleScroll();
    }, { passive: true });
  }

  updateActiveDot(activeIndex) {
    this.dots.forEach((dot, index) => {
      if (index === activeIndex) {
        dot.classList.add('active');
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.classList.remove('active');
        dot.removeAttribute('aria-current');
      }
    });
  }

  static initializeObserver() {
    if (this.observer) {
      this.observer.disconnect();
    }

    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          if (document.querySelector('.complementary-products__container')) {
            console.log('Complementary container found after DOM mutation');
            this.observer.disconnect();
            new ComplementarySlider();
          }
        }
      });
    });

    // Start observing
    this.observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
}

// Only initialize on product pages or pages that might have complementary products
function shouldInitializeSlider() {
  // Check if we're on a product page or if complementary products container exists
  return document.body.classList.contains('template-product') || 
         document.querySelector('.complementary-products__container') ||
         document.querySelector('product-recommendations');
}

// Initialize observer only if we should
if (shouldInitializeSlider()) {
  ComplementarySlider.initializeObserver();
}

// Also try on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  if (shouldInitializeSlider()) {
    console.log('DOM Content Loaded - checking for slider');
    if (document.querySelector('.complementary-products__container')) {
      new ComplementarySlider();
    }
  }
});

// And on Shopify section load
document.addEventListener('shopify:section:load', (event) => {
  if (shouldInitializeSlider()) {
    console.log('Section loaded - checking for slider');
    if (event.target.querySelector('.complementary-products__container')) {
      new ComplementarySlider();
    }
  }
}); 